import React, {
  FunctionComponent,
  useState,
  ChangeEvent,
  useEffect,
  KeyboardEvent,
} from "react";
import { WizardProps } from "../../containers/Wizard";
import ButtonOptions from "../ButtonOptions";
import { noNormalizer } from "../../shared/normalizers";

type SimpleStepProps = {
  previous?: string;
  next: string;
  question: string;
  target?: string;
  description: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  validation?: Function;
  spellName: string;
  wizard: WizardProps;
  normalizer?: Function;
};

export const SimpleStep: FunctionComponent<SimpleStepProps> = ({
  previous,
  next,
  question,
  target,
  description,
  placeholder = "Type your answer here...",
  type = "text",
  required = true,
  validation,
  spellName,
  wizard,
  normalizer = noNormalizer,
}: SimpleStepProps) => {
  const initialValue = normalizer(String(wizard.invocations[spellName] || ""));
  const [input, setInput] = useState<HTMLInputElement | null>();
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue, setValue]);
  const onChange = (val: ChangeEvent<HTMLInputElement>) => {
    setValue(normalizer(val.target.value));
  };
  const handleSubmit = () => {
    if (!input?.reportValidity()) return;

    const invalid = validation ? validation(value) : null;
    if (invalid) console.log(invalid);
    else if (initialValue === value) wizard.changePath(next);
    else {
      if (spellName === 'phone' && (wizard?.publisher.country === 'US' || wizard?.publisher.country === 'CA')) {
        wizard.invocate(spellName, `+1${value}`, next);
      } else {
        wizard.invocate(spellName, value, next);
      }
    }
  };
  const onKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") handleSubmit();
  };
  const renderTarget = () => {
    if (target) return <strong> {target}</strong>;
  };

  return (
    <div className="question">
      <h3>
        {question}
        {renderTarget()}?
      </h3>
      <h4>{description}</h4>
      <input
        ref={(el) => setInput(el)}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        required={required}
        autoFocus
      />
      <ButtonOptions
        changePath={wizard.changePath}
        previous={previous}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default SimpleStep;
